
import bridge from './bridge'
import { miniAppNavigateTo, miniAppPostMessage, miniAppSwitchTab, miniAppReLaunch } from './tools'

// 判断是否是小程序环境
export function isWxMiniprogrameEnv () {
  console.log(window)
  return window.__wxjs_environment === 'miniprogram'
}

// 判断是否是微信环境
export function isWxEnv () {
  const ua = navigator.userAgent
  const isWx = /micromessenger/.test(ua.toLowerCase())
  return isWx
}

// 判断是否是支付宝环境
export function isAlipayEnv () {
  const isAlipay = /AlipayClient/.test(window.navigator.userAgent)
  return isAlipay
}

// 设置小程序分享
export function setMiniProgramShare (data) {
  try {
    miniAppPostMessage({ data: data })
  } catch (ex) {
    console.error(ex)
  }
}

// 设置支付宝分享
export function aliShare (data) {
  try {
    window.my.postMessage({ data: data })
  } catch (ex) {
    console.error(ex)
  }
}

// 跳转到小程序产品详情页
export function toMiniProgramProduct (type) {
  try {
    const prodId = 91544
    const path = `/pagesA/product/prodDetail/index?brand=${type}&showPid=${prodId}&pickPid=${prodId}`
    miniAppNavigateTo(path)
  } catch (ex) {
    console.error(ex)
  }
}

// 承接页映射
const themePageMap = {
  christmas: '/pages/webview/index?url=https://m.haimati.cn/#/themeChristmas',
  newYear: '/pages/webview/index?url=https://m.haimati.cn/#/themeDawnBlue'
}

// 跳转到小程序产品承接页
export function toMiniProgramThemePage (theme) {
  try {
    miniAppNavigateTo(themePageMap[theme])
  } catch (ex) {
    console.error(ex)
  }
}

// 跳转到小程序儿童tab下
export function toMiniProgramKids () {
  try {
    miniAppReLaunch('/pages/index/index?brandNav=kids&brandId=3')
  } catch (ex) {
    console.error(ex)
  }
}

// 跳转到海马体大师tab下
export function toMiniProgramGold () {
  try {
    miniAppReLaunch('/pages/index/index?brandNav=gold&brandId=2')
  } catch (ex) {
    console.error(ex)
  }
}

// 跳转到小程序首页
export function toMiniProgramHome () {
  try {
    const isMini = isWxMiniprogrameEnv() || window.my
    const isWx = isWxEnv()
    if (isMini) {
      miniAppSwitchTab('/pages/index/index')
    } else if (isWx) {
      window.location.href = process.env.VUE_APP_H5_HOME
    } else {
      bridge.sendData('gotoHome', { type: 'index' }, null)
    }
  } catch (ex) {
    console.error(ex)
  }
}

export function toMiniProgramLogin () {
  try {
    const isWx = isWxMiniprogrameEnv()
    if (isWx || window.my) {
      // 跳转到小程序登录页
      localStorage.removeItem('x-stream-id')
      miniAppNavigateTo('/pagesPreload/loginByPhone/index?back=true')
    } else {
      // 跳转到h5登录页
      const locationHref = JSON.parse(JSON.stringify(window.location.href))
      window.location.href = `${process.env.VUE_APP_H5_LOGIN_URL}?returnUrl=${locationHref}`
    }
  } catch (ex) {
    console.error(ex)
  }
}
